import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=3f0fc5d4&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=3f0fc5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0fc5d4",
  null
  
)

export default component.exports